import { Box, Typography } from '@mui/material';

import TAGLink from '@/components/TAGLink';
import { AdFooterFooterPolicyGroupCollection, Maybe, NavigationLink, Page } from '@/types/generated';
import { resolveLinkTitle, resolveLinkUrl } from '@/components/FooterLite/FooterLite.helpers';
import { PrivacyOptions } from '@/assets/SVG';

import { isOneTrustLink } from '../Footer/Footer.helpers';

import { getNavLinkStyles, policyGroupStyle } from './FooterAlt.styles';

export function PolicyLinks({ policyGroup }: { readonly policyGroup?: Maybe<AdFooterFooterPolicyGroupCollection> }) {
	if (!policyGroup?.items) return null;
	const groupItems = policyGroup?.items;

	if (!groupItems) return null;
	return (
		<Box data-test-id="section_footeralt_policylinks" sx={policyGroupStyle}>
			{groupItems?.map((link: Maybe<NavigationLink | Page> | undefined, idx) => {
				if (!link) return null;
				const isOneTrust = isOneTrustLink(link as NavigationLink);
				return (
					<TAGLink
						key={link.sys.id}
						href={resolveLinkUrl(link)}
						openInNewTab={(link as NavigationLink)?.openInNewTab || false}
						dataTestId={isOneTrust ? `link_for_group_one-trust` : `link_for_group_${link.sys.id}`}
						linkSx={isOneTrust ? { display: 'inline-flex', alignItems: 'center' } : {}}
						onClick={
							isOneTrust
								? (e) => {
										e.preventDefault();
										window?.OneTrust?.ToggleInfoDisplay();
								  }
								: undefined
						}
					>
						{isOneTrust && (
							<PrivacyOptions dataTestId={`privacy_icon_${link?.sys.id ?? idx}`} verticalAlign="middle" />
						)}
						<Typography color="text.light" sx={getNavLinkStyles()} title={resolveLinkTitle(link)}>
							{resolveLinkTitle(link)}
						</Typography>
					</TAGLink>
				);
			})}
		</Box>
	);
}
interface IFooterAltPolicyProps {
	isMobile: boolean;
	policyGroup?: Maybe<AdFooterFooterPolicyGroupCollection>;
}
const FooterAltPolicy = ({ isMobile, policyGroup }: IFooterAltPolicyProps) => {
	return (
		<Box
			data-test-id="section_footeralt_policy"
			flexDirection={isMobile ? 'row' : 'column'}
			display={'flex'}
			justifyContent={'space-between'}
			width={'100%'}
			gap={2}
		>
			<PolicyLinks policyGroup={policyGroup} />
		</Box>
	);
};

export default FooterAltPolicy;
